import { render, staticRenderFns } from "./TheNovelProject.vue?vue&type=template&id=a0168574&scoped=true"
import script from "./TheNovelProject.vue?vue&type=script&lang=ts"
export * from "./TheNovelProject.vue?vue&type=script&lang=ts"
import style0 from "./TheNovelProject.vue?vue&type=style&index=0&id=a0168574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0168574",
  null
  
)

export default component.exports